import React from 'react';
import SidebarItem from './SidebarItem';
import {
  getCurrentRole,
  hasPermission,
  Permission
} from '../../constants/roles';

interface MenuItem {
  icon: string;
  label: string;
  active: boolean;
  path: string;
  permission?: Permission;
}

const Sidebar = () => {
  const role = getCurrentRole();

  const menuItems: MenuItem[] = [
    {
      icon: 'Home',
      label: 'Dashboard',
      active: true,
      path: '/dashboard'
    },
    {
      icon: 'Folder',
      label: 'Cases',
      active: false,
      path: '/cases',
      permission: Permission.VIEW_CASES
    },
    {
      icon: 'Chat',
      label: 'Sessions',
      active: false,
      path: '/sessions',
      permission: Permission.VIEW_SESSIONS
    },
    {
      icon: 'User2',
      label: 'Counsellors',
      active: false,
      path: '/counsellors',
      permission: Permission.VIEW_COUNSELLORS
    },
    {
      icon: 'User2',
      label: 'Emergency Responders',
      active: false,
      path: '/emergency-responders',
      permission: Permission.VIEW_COUNSELLORS
    },
    {
      icon: 'Chart',
      label: 'Analytics',
      active: false,
      path: '/analytics'
    },
    {
      icon: 'Category',
      label: 'Resources',
      active: false,
      path: '/resources',
      permission: Permission.MANAGE_RESOURCES
    },
    {
      icon: 'Setting',
      label: 'Accounts',
      active: false,
      path: '/accounts'
    }
  ];

  const visibleItems = menuItems.filter(
    (item) => !item.permission || hasPermission(role, item.permission)
  );

  return (
    <>
      {visibleItems.map((item, index) => {
        const { label, icon, path } = item;
        return (
          <SidebarItem
            label={label}
            icon={icon}
            path={path}
            key={label + index}
          />
        );
      })}
    </>
  );
};

export default Sidebar;
